import { render } from "./users.vue?vue&type=template&id=6bd58eee"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__